import React from "react";
import Link from "next/link";
import Image from "next/image";
import classNames from "classnames";

import CheckCircleIcon from "assets/iconsv2/check-circle-16.svg";
import CodeBlockIcon from "assets/iconsv2/code-block-16.svg";
import LinkIcon from "assets/iconsv2/link-16.svg";
import SnippetsIcon from "assets/iconsv2/snippets-16.svg";

import TeamsExample from "assets/home/teams/teams-example.png";

import Container from "components/Container";

import Subtitle from "./Subtitle";

import styles from "./Teams.module.css";
import BlockCallToAction from "./BlockCallToAction";

const Teams: React.FC = () => {
  return (
    <>
      <Subtitle>
        <h3>Raycast for Teams</h3>
        <p>Keep your team communicating efficiently and building faster with a shared space in Raycast.</p>
      </Subtitle>
      <Container size="lg">
        <div className={styles.saveTime}>
          <div className={styles.text}>
            <div className={classNames(styles.icon, styles.iconLight)}>
              <CheckCircleIcon />
            </div>
            <h4>Save time on everyday tasks</h4>

            <p>
              Raycast isn&rsquo;t just a tool for individuals. It&rsquo;s also a tool, designed for sharing. From custom
              extensions, to Quicklinks and Snippets.
            </p>
            <p>
              What your team needs to get done, we offer an fabulously rich toolkit to do it swiftly, and at ease with
              your whole organization in harmony.
            </p>

            <Link href="/teams">
              <a className={styles.button}>Learn more</a>
            </Link>
          </div>
          <div className={classNames(styles.image, styles.extensionExample)}>
            <div>
              <Image
                src={TeamsExample}
                width={846}
                height={571}
                layout="fixed"
                alt="An example Raycast window showing a grid of fictional team members"
              />
            </div>
          </div>
        </div>

        <div className={styles.collection}>
          <div className={styles.infoBlock}>
            <div className={classNames(styles.icon, styles.iconLight)}>
              <CodeBlockIcon />
            </div>
            <h4>Shared Commands</h4>

            <p>
              Use React and TypeScript to build custom tooling that unlocks teams within your oganization to do their
              best work, at speed. Share them in your private extension store.
            </p>
          </div>
          <div className={styles.infoBlock}>
            <div className={classNames(styles.icon, styles.iconLight)}>
              <LinkIcon />
            </div>
            <h4>Shared Quicklinks</h4>

            <p>
              Effortlessly share common links with your team, such as project documentation in Notion, GitHub repos,
              Linear projects, and data dashboards - all with Quicklinks.
            </p>
          </div>
          <div className={styles.infoBlock}>
            <div className={classNames(styles.icon, styles.iconLight)}>
              <SnippetsIcon />
            </div>
            <h4>Shared Snippets</h4>

            <p>
              Create consistency with saved support responses, common text such as emails or addresses, and use dynamic
              placeholders for smart keyword expansion.
            </p>
          </div>
        </div>

        <BlockCallToAction href="/help/teams" target="_blank" rel="noreferrer">
          Learn about developing for teams
        </BlockCallToAction>
      </Container>
    </>
  );
};

export default Teams;
